import axios from "axios";
import qs from "qs";
import {getToken, getUser} from "../database/UserDal";
import {englishNumber} from "./utils";
import {Platform} from "react-native";

var baseUrl = "https://panel.asandarman.ir/AD2/api/web/v1/";

// var baseUrl = 'http://212.33.206.20/AD2/api/web/v1/'

function log(error, message) {
  if (__DEV__) console.log(message);
}

function getHeader() {
  var token = getToken();
  if (token != null) {
    return "Bearer " + token;
  }
}

export const signupRequest = (
  mobile,
  fname,
  lname,
  ncode,
  codemoaref,
  callback
) => {
  axios
    .post(
      baseUrl + "customer/signupcustomer",
      qs.stringify({
        fname: fname,
        lname: lname,
        cellphone: mobile,
        ncode: ncode,
        typedevice: Platform.OS,
        codemoaref: codemoaref,
      })
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const editProfileRequest = (
  email,
  fname,
  lname,
  phone,
  cityid,
  areanumber,
  koche,
  vahed,
  pelak,
  address,
  sex,
  bimeid,
  bimecode,
  bimedate,
  lat,
  lng,
  ncode,
  callback
) => {
  axios
    .post(
      baseUrl + "customer/updateprofile",
      qs.stringify({
        fname: fname,
        lname: lname,
        email: email,
        phone: phone,
        cityid: cityid,
        areanumber: areanumber,
        koche: koche,
        vahed: vahed,
        pelak: pelak,
        address: address,
        bimeid: bimeid,
        bimecode: bimecode,
        bimedate: bimedate,
        sex: sex,
        lat: lat,
        lng: lng,
        ncode: ncode,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const loginRequest = (mobile, callback) => {
  axios
    .post(
      baseUrl + "customer/logincustomer",
      qs.stringify({
        cellphone: mobile,
        typedevice: Platform.OS,
      })
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const activationRequest = (active_code, callback) => {
  axios
    .post(
      baseUrl + "customer/activecustomer",
      qs.stringify({
        active_code: active_code,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const advertisingsRequest = callback => {
  axios
    .get(baseUrl + "informations/getadvertisings", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const myAddresBooksRequest = callback => {
  axios
    .get(baseUrl + "customer/alladdressbook", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const addresBookRequest = (id, callback) => {
  axios
    .get(baseUrl + "customer/alladdressbook/" + id, {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const getActiveRequest = callback => {
  axios
    .get(baseUrl + "customer/backactioveorder", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const createAddressBookRequest = (
  name,
  cityid,
  areanumber,
  address,
  koche,
  vahed,
  pelak,
  lat,
  lng,
  comment,
  callback
) => {
  axios
    .post(
      baseUrl + "customer/newaddressbook",
      qs.stringify({
        nameaddress: name,
        cityid: cityid,
        areanumber: areanumber,
        address: address,
        koche: koche,
        vahed: vahed,
        pelak: pelak,
        comment: comment,
        lat: lat,
        lng: lng,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const editAddressBookRequest = (
  id,
  name,
  cityid,
  areanumber,
  address,
  koche,
  vahed,
  pelak,
  lat,
  lng,
  comment,
  callback
) => {
  axios
    .post(
      baseUrl + "customer/editaddressbook",
      qs.stringify({
        id: id,
        nameaddress: name,
        cityid: cityid,
        areanumber: areanumber,
        address: address,
        koche: koche,
        comment: comment,
        vahed: vahed,
        pelak: pelak,
        lat: lat,
        lng: lng,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const removeAddressBookRequest = (id, callback) => {
  axios
    .post(
      baseUrl + "customer/deleteaddressbook",
      qs.stringify({
        id: id,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const refreshToken = callback => {
  axios
    .post(
      baseUrl + "customer/refreshtoken",
      {},
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const findAddressRequest = (lat, lng, callback) => {
  axios
    .post(
      baseUrl + "informations/getaddressbylocation",
      qs.stringify({
        lat: lat,
        lng: lng,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const myRebateCodeRequest = callback => {
  axios
    .get(baseUrl + "customer/myrebatecode", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const myProfileRequest = callback => {
  axios
    .get(baseUrl + "customer/getmyprofile", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const citiesRequest = callback => {
  axios
    .get(baseUrl + "informations/getcities", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const areaRequest = (id, callback) => {
  axios
    .get(baseUrl + "informations/getareas/" + id, {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const sectionsRequest = callback => {
  axios
    .get(baseUrl + "informations/getsections", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const addFeedbackRequest = (subject, body, id_section, callback) => {
  axios
    .post(
      baseUrl + "informations/addfeedback",
      qs.stringify({
        subject: subject,
        body: body,
        id_section: id_section,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const notifictionRequest = callback => {
  axios
    .get(baseUrl + "customer/alldeclarations", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const notifictionNumberRequest = callback => {
  axios
    .get(baseUrl + "customer/numberofdeclarations", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const walletInfoRequest = callback => {
  axios
    .get(baseUrl + "customer/baginfo", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const walletChargeRequest = (price, callback) => {
  axios
    .post(
      baseUrl + "customer/shargebag",
      qs.stringify({
        price: price,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const favoritPersonsRequest = callback => {
  axios
    .get(baseUrl + "customer/allmarksbook", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const myfavoritServantRequest = callback => {
  axios
    .get(baseUrl + "customer/listfavservants", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const allServantRequest = callback => {
  axios
    .get(baseUrl + "customer/listmyservants", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const createFavoritPersonRequest = (
  typerelation,
  flname,
  sex,
  cellphone,
  phone,
  codemeli,
  callback
) => {
  axios
    .post(
      baseUrl + "customer/newmarkbook",
      qs.stringify({
        typerelation: typerelation,
        flname: flname,
        sex: sex,
        cellphone: englishNumber(cellphone),
        phone: englishNumber(phone),
        codemeli: englishNumber(codemeli),
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const editFavoritPersonRequest = (
  id,
  typerelation,
  flname,
  sex,
  cellphone,
  phone,
  codemeli,
  callback
) => {
  axios
    .post(
      baseUrl + "customer/editmarkbook",
      qs.stringify({
        id: id,
        typerelation: typerelation,
        flname: flname,
        sex: sex,
        cellphone: englishNumber(cellphone),
        phone: englishNumber(phone),
        codemeli: englishNumber(codemeli),
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const removeFavoritPersonRequest = (id, callback) => {
  axios
    .post(
      baseUrl + "customer/deletemarkbook",
      qs.stringify({
        id: id,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const aboutussRequest = callback => {
  axios
    .get(baseUrl + "informations/aboutus", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const rulesRequest = callback => {
  axios
    .get(baseUrl + "informations/rules/customer", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const cartChooseAddressRequest = (
  addressid,
  cityid,
  areaid,
  koche,
  vahed,
  pelak,
  address,
  lat,
  lng,
  comment,
  callback
) => {
  axios
    .post(
      baseUrl + "cart/selectaddress",
      qs.stringify({
        addressid: addressid,
        cityid: cityid,
        areaid: areaid,
        koche: koche,
        vahed: vahed,
        pelak: pelak,
        address: address,
        lat: lat,
        lng: lng,
        comment: comment,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const orderSelectInsurance = (id, callback) => {
  axios
    .post(
      baseUrl + "cart/selectinsurance",
      qs.stringify({
        id_insurance: id,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const getActiveInsurances = callback => {
  axios
    .get(baseUrl + "informations/getactiveinsuranses", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const isActiveInsuranceRequest = callback => {
  axios
    .get(baseUrl + "informations/isactiveinsuranse", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const servicesRequest = callback => {
  axios
    .get(baseUrl + "service/getallservices", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const serviceRequest = (id, callback) => {
  axios
    .get(baseUrl + "service/getallservicedetails/" + id, {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const addtoCartRequest = (id, callback) => {
  axios
    .post(
      baseUrl + "cart/addtocart",
      qs.stringify({
        iddetail: id,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const viewCartRequest = callback => {
  axios
    .get(baseUrl + "cart/viewcart", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const ordersRequest = callback => {
  axios
    .get(baseUrl + "customer/orderslist", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const orderRequest = (id, callback) => {
  axios
    .get(baseUrl + "customer/orderdetails/" + id, {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const supportNumberRequest = callback => {
  axios
    .get(baseUrl + "informations/suportnumber", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const ratePointsRequest = callback => {
  axios
    .get(baseUrl + "informations/getlistpoint", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const changeCountCartRequest = (id, number, callback) => {
  axios
    .post(
      baseUrl + "cart/changenumberofcart",
      qs.stringify({
        id: id,
        number: number,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const removeItemCartRequest = (id, callback) => {
  axios
    .post(
      baseUrl + "cart/deleteofcart",
      qs.stringify({
        id: id,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const getNeedInfoRequest = callback => {
  axios
    .post(
      baseUrl + "cart/needinfocart",
      {},
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n) {
    u8arr[n - 1] = bstr.charCodeAt(n - 1);
    n -= 1; // to make eslint happy
  }
  return new File([u8arr], filename, {type: mime});
};
export const completeOrderRequest = (
  iddefuser,
  name,
  sexsick,
  phone,
  codemeli,
  cellphone,
  isequipment,
  codebime,
  rebatecode,
  textfield,
  id_fav_servant,
  callback
) => {
  let formData = new FormData();
  if (textfield != null && textfield.uri != null) {
    const file = dataURLtoFile(textfield.uri, "temp.jpg");
    formData.append("textfield", file, file.name);
  } else {
    formData.append("textfield", textfield);
  }

  formData.append("iddefuser", iddefuser.toString());
  formData.append("name", name);
  formData.append("sexsick", sexsick);
  formData.append("phone", phone);
  formData.append("codemeli", codemeli);
  formData.append("cellphone", cellphone);
  formData.append("isequipment", isequipment);
  formData.append("codebime", codebime);
  formData.append("rebatecode", rebatecode);
  formData.append("id_fav_servant", id_fav_servant);

  axios
    .post(baseUrl + "cart/completeinfoorder", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const saveTokenRequest = (token, callback) => {
  axios
    .post(
      baseUrl + "customer/savetokenpush",
      qs.stringify({
        token: token,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const cancelOrderRequest = (order_id, callback) => {
  axios
    .post(
      baseUrl + "customer/cancelorder",
      qs.stringify({
        order_id: order_id,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const addExpertFavRequest = (id, callback) => {
  axios
    .post(
      baseUrl + "customer/addfavservant",
      qs.stringify({
        id: id,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const removeExpertFavRequest = (id, callback) => {
  axios
    .post(
      baseUrl + "customer/deletefavservant",
      qs.stringify({
        id: id,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const addPointRequest = (order_id, star, point_ids, callback) => {
  axios
    .post(
      baseUrl + "customer/addpoints",
      qs.stringify({
        id_order: order_id,
        star: star,
        text: "",
        point_ids: point_ids,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const deleteAccountRequest = callback => {
  axios
    .post(
      baseUrl + "customer/deleteaccount",
      {},
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const payOrderRequest = (order_id, type_pay, callback) => {
  axios
    .post(
      baseUrl + "customer/payorder",
      qs.stringify({
        order_id: order_id,
        type_pay: type_pay,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const versionAppRequest = callback => {
  axios
    .get(baseUrl + "informations/versionapp", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const paySessionRequest = (
  id_session,
  type_select,
  type_pay,
  callback
) => {
  axios
    .post(
      baseUrl + "customer/paysession",
      qs.stringify({
        id_session: id_session,
        type_select: type_select,
        type_pay: type_pay,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const doSessionRequest = (id_session, status_customer, callback) => {
  axios
    .post(
      baseUrl + "customer/wantsession",
      qs.stringify({
        id_session: id_session,
        status_customer: status_customer,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const getRecieptRequest = (orderId, callback) => {
  axios
    .get(baseUrl + "customer/getreciept/" + orderId, {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
export const searchAddressRequest = (search, lat, lng, callback) => {
  axios
    .post(
      `https://api.cedarmaps.com/v1/token`,
      qs.stringify({
        client_id: "asandarman-4844832827669335489",
        client_secret:
          "cC-OaWFzYW5kYXJtYW6JFTunT4N2z6Ef-kyz7jVCWHuphwLB-lGjlIH9IG1F9A==",
      })
    )
    .then(response => {
      axios
        .get(
          `https://api.cedarmaps.com/v1/geocode/cedarmaps.streets/${search}?location=${lat},${lng}&distance=40&limit=10&access_token=${response.data.access_token}`
        )
        .then(response => {
          callback(true, response.data);
        })
        .catch(error => {
          callback(false, error);
        });
    })
    .catch(error => {
      callback(false, error);
    });
};
export const logoutRequest = callback => {
  axios
    .post(
      baseUrl + "customer/logout",
      {},
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const checkExpertFavRequest = (sex, callback) => {
  axios
    .post(
      baseUrl + "cart/selectfavservant",
      qs.stringify({
        sex: sex,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};

export const sendToAllRequest = (id, callback) => {
  axios
    .post(
      baseUrl + "customer/sendtoallservants",
      qs.stringify({
        id: id,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then(response => {
      log(true, response);
      callback(true, response.data);
    })
    .catch(error => {
      log(false, error);
      callback(false, error);
    });
};
